document.addEventListener("DOMContentLoaded", () => {
  initBoaFinder();
});

let currentLat = null;
let currentLng = null;
let isGettingLocation = false;

// =========================
// initAutocomplete input
// =========================
function initBoaFinderAutocomplete() {
  const finderElm = document.getElementById("boa-finder-popup");
  if (finderElm?.dataset.initialized) {
    return true;
  }
  const addressInput = document.getElementById("boa-finder-address");
  if (!window.google?.maps?.places) {
    console.warn("Google Maps Places library not available yet.");
    return;
  }
  if (!addressInput) {
    return;
  }

  const autoCompleteRef = new google.maps.places.Autocomplete(addressInput, {
    componentRestrictions: { country: "il" },
    fields: ["formatted_address", "geometry"],
    language: "iw",
  });

  autoCompleteRef.addListener("place_changed", function () {
    const place = autoCompleteRef.getPlace();
    if (place.formatted_address && place.geometry?.location) {
      currentLat = place.geometry.location.lat();
      currentLng = place.geometry.location.lng();
    }
  });
  finderElm.setAttribute("data-initialized", "true");
  return true;
}
window.initBoaFinderAutocomplete = initBoaFinderAutocomplete;

// Ensure init if when maps package was loaded, the init fn was not ready.
let initIntervalCount = 0;
const initInterval = setInterval(() => {
  initIntervalCount += 1;
  if (initIntervalCount > 5) {
    clearInterval(initInterval);
  }
  const isInitializedAlready = initBoaFinderAutocomplete();
  if (!isInitializedAlready) {
    console.warn("Finder autocomplete was not initialized properly");
  }
}, 500);

// =========================
// The actual init function
// =========================
function initBoaFinder() {
  const finderOpener = document.getElementById("boa-finder-opener");
  const finderContainer = document.getElementById("boa-finder-container");
  const finderCloseButton = document.getElementById(
    "boa-finder-popup-close-button"
  );

  finderOpener?.addEventListener("click", showBoaFinderPopup);
  finderCloseButton?.addEventListener("click", hideBoaFinderPopup);
  finderContainer?.addEventListener("click", (e) => {
    if (e.target === finderContainer) {
      hideBoaFinderPopup();
    }
  });

  const locateBtn = document.getElementById("boa-finder-locate-btn");
  if (locateBtn && !locateBtn.hasAttribute("data-listener-attached")) {
    locateBtn.setAttribute("data-listener-attached", "true");
    locateBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleFindMe();
    });
  }

  const finderElm = document.getElementById("boa-finder-popup");
  if (!finderElm) {
    console.warn("Finder popup not in DOM");
    return;
  }
  if (finderElm.dataset.initialized === "true") {
    return;
  }

  const searchBtn = document.getElementById("boa-finder-search-btn");
  if (searchBtn) {
    searchBtn.addEventListener("click", handleBoaFinderSearch);
  }
}

// =========================
// handleSearch => "חיפוש" button
// =========================
async function handleBoaFinderSearch() {
  hideBoaFinderError();
  try {
    const alertEl = document.getElementById("boa-finder-alert");
    const storesEl = document.getElementById("boa-finder-stores");
    const addressEl = document.getElementById("boa-finder-address");
    const variantBarcodeSelectEl = document.getElementById("boa-finder-variant-select");
    if (!storesEl || !addressEl || !variantBarcodeSelectEl) {
      console.warn("Some elements not found in DOM");
      return;
    }
    alertEl?.classList.remove("show");
    storesEl.innerHTML = "";
    if (!addressEl.value.trim()) {
      showBoaFinderError(FoxTheme.boaFinderStrings.errorEmptyAddress);
      return;
    }
    // call the Finder API
    if (!currentLat || !currentLng) {
      return;
    }
    const itemCode = variantBarcodeSelectEl.value.trim().replace(/\D+/g, "");
    if (!itemCode) {
      throw new Error("Bad barcode");
    }
    const apiUrl = `https://jacobifinderapp.jacobi.co.il/api/getstores?ItemCode=${itemCode}&longitude=${currentLng}&latitude=${currentLat}`;
    const storeResp = await fetch(apiUrl);
    const storeData = await storeResp.json();

    if (!storeResp.ok) {
      if (
        storeResp.status === 404 &&
        storeData.error === "No stores found for the specified product."
      ) {
        showBoaFinderError(FoxTheme.boaFinderStrings.productNotFoundInArea);
        return;
      }
      throw new Error(
        storeData.error || FoxTheme.boaFinderStrings.errorFetchingStores
      );
    }

    if (Array.isArray(storeData)) {
      if (!storeData.length) {
        showBoaFinderError(FoxTheme.boaFinderStrings.productNotFoundInArea);
        return;
      }
      alertEl.classList.add("show");

      storeData.forEach((store) => {
        const cardHTML = renderStoreCard(store);
        storesEl.insertAdjacentHTML("beforeend", cardHTML);
      });
    } else {
      throw new Error(FoxTheme.boaFinderStrings.errorFetchingStores);
    }
  } catch (err) {
    console.error("Search error:", err);
    showBoaFinderError(
      err.message || FoxTheme.boaFinderStrings.errorFetchingStores
    );
  }
}

// =========================
// renderStoreCard
// =========================
function renderStoreCard(store) {
  let distanceText = "";
  if (store.distance) {
    if (store.distance.includes("km")) {
      const numericVal = parseFloat(store.distance);
      distanceText = `${numericVal} ${FoxTheme.boaFinderStrings.distanceKM}`;
    } else {
      const numericVal = parseFloat(store.distance);
      distanceText = `${numericVal} ${FoxTheme.boaFinderStrings.distanceM}`;
    }
  }
  const isFeaturedClass = store.isfeatured ? "boa-finder-store--featured" : "";
  const isVipClass = store.isvip ? "boa-finder-store--vip" : "";

  const wazeAddress = encodeURIComponent(
    `${store.storeaddress || ""}, ${store.storecity || ""}`
  );
  const wazeUrl = `https://waze.com/ul?q=${wazeAddress}&navigate=yes`;

  // Location icon SVG with appropriate color
  const locationSvg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0,0,256,256">
<g fill="${
    store.isfeatured ? "#ffffff" : "#CE1B6C"
  }" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M4,6v5l-0.125,0.84375c-0.03516,0.20703 -0.875,5.10156 -0.875,7.65625c0,1.61719 0.37891,2.90625 1.0625,3.84375c-0.01953,-0.01172 -0.04297,-0.01953 -0.0625,-0.03125v24.6875h42v-24.6875c-0.01953,0.01172 -0.03906,0.01953 -0.0625,0.03125c0.68359,-0.9375 1.0625,-2.22656 1.0625,-3.84375c0,-2.55469 -0.83984,-7.44922 -0.875,-7.65625l-0.15625,-0.84375h0.03125v-5zM5.6875,13h4.3125v8.90625c-0.65625,0.67969 -1.57812,1.09375 -2.5,1.09375c-1.66016,0 -2.5,-1.17969 -2.5,-3.5c0,-1.78906 0.45703,-4.98828 0.6875,-6.5zM12,13h5v8.90625c-0.65625,0.67969 -1.57812,1.09375 -2.5,1.09375c-0.92187,0 -1.84375,-0.41797 -2.5,-1.09375zM19,13h5v8.90625c-0.65625,0.67969 -1.57812,1.09375 -2.5,1.09375c-0.92187,0 -1.84375,-0.41797 -2.5,-1.09375zM26,13h5v8.90625c-0.65625,0.67969 -1.57812,1.09375 -2.5,1.09375c-0.92187,0 -1.84375,-0.41797 -2.5,-1.09375zM33,13h5v8.90625c-0.65625,0.67969 -1.57812,1.09375 -2.5,1.09375c-0.92187,0 -1.84375,-0.41797 -2.5,-1.09375zM40,13h4.28125c0.23828,1.51172 0.71875,4.71094 0.71875,6.5c0,2.32031 -0.83984,3.5 -2.5,3.5c-0.92187,0 -1.84375,-0.41797 -2.5,-1.09375zM10,30h16v12h-16zM31,30h9v16h-9z"></path></g></g>
</svg>`;

  // Phone icon SVG
  const phoneSvg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256">
<g fill="${
    store.isfeatured ? "#CE1B6C" : "#ffffff"
  }" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="translate(24.12166,276.05705) rotate(-100) scale(5.12,5.12)"><path d="M39.03125,47c-0.01562,0 -0.03125,0 -0.04687,0c-7.51562,-0.24609 -16.32031,-7.53125 -22.38672,-13.60156c-6.07422,-6.07031 -13.35937,-14.87891 -13.59375,-22.35937c-0.08594,-2.625 6.35547,-7.29297 6.42188,-7.33984c1.67188,-1.16406 3.52734,-0.75 4.28906,0.30469c0.51563,0.71484 5.39844,8.11328 5.92969,8.95313c0.55078,0.87109 0.46875,2.16797 -0.21875,3.46875c-0.37891,0.72266 -1.63672,2.93359 -2.22656,3.96484c0.63672,0.90625 2.32031,3.12891 5.79688,6.60547c3.48047,3.47656 5.69922,5.16406 6.60938,5.80078c1.03125,-0.58984 3.24219,-1.84766 3.96484,-2.22656c1.28125,-0.67969 2.57031,-0.76562 3.44922,-0.22656c0.89844,0.55078 8.27734,5.45703 8.95703,5.92969c0.57031,0.40234 0.9375,1.08984 1.01172,1.89063c0.07031,0.80859 -0.17969,1.66406 -0.69922,2.41016c-0.04297,0.0625 -4.65625,6.42578 -7.25781,6.42578z"></path></g></g>
</svg>`;

  // Nav icon SVG
  const navSvg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256">
<g fill="${
    store.isfeatured ? "#CE1B6C" : "#ffffff"
  }" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M25,1c-8.82031,0 -16,7.17969 -16,16c0,14.11328 14.62891,30.94531 15.25,31.65625c0.19141,0.21875 0.46094,0.34375 0.75,0.34375c0.30859,-0.01953 0.55859,-0.125 0.75,-0.34375c0.62109,-0.72266 15.25,-17.84375 15.25,-31.65625c0,-8.82031 -7.17969,-16 -16,-16zM25,12c3.3125,0 6,2.6875 6,6c0,3.3125 -2.6875,6 -6,6c-3.3125,0 -6,-2.6875 -6,-6c0,-3.3125 2.6875,-6 6,-6z"></path></g></g>
</svg>`;

  // VIP star SVG
  const starSvg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 48 48">
<linearGradient id="q0c2dLEp_4LHk~8cW2fATa_8ggStxqyboK5_gr1" x1="9.009" x2="38.092" y1="6.36" y2="45.266" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffda1c"></stop><stop offset="1" stop-color="#feb705"></stop></linearGradient><path fill="url(#q0c2dLEp_4LHk~8cW2fATa_8ggStxqyboK5_gr1)" d="M24.913,5.186l5.478,12.288l13.378,1.413c0.861,0.091,1.207,1.158,0.564,1.737l-9.993,9.005  l2.791,13.161c0.18,0.847-0.728,1.506-1.478,1.074L24,37.141l-11.653,6.722c-0.75,0.432-1.657-0.227-1.478-1.074l2.791-13.161   l-9.993-9.005c-0.643-0.579-0.296-1.646,0.564-1.737l13.378-1.413l5.478-12.288C23.439,4.395,24.561,4.395,24.913,5.186z"></path>
</svg>`;

  const vipRibbonHtml = store.isvip
    ? `
        <div class="boa-finder-store-ribbon">
            ${starSvg}
            <p class="boa-finder-store-ribbon-text">${FoxTheme.boaFinderStrings.vipRibbonText}</p>
        </div>
      `
    : "";

  const callButton = store.storephone
    ? `
        <a href="tel:${store.storephone}" class="boa-finder-store-callbtn">
            ${phoneSvg}
            <span>${FoxTheme.boaFinderStrings.callBtnText}</span>
        </a>
      `
    : "";

  const navigateButton = `
        <a href="${wazeUrl}" class="boa-finder-store-navbtn" target="_blank">
            ${navSvg}
            <span>${FoxTheme.boaFinderStrings.navigateBtnText}</span>
        </a>
    `;

  return `
        <div class="boa-finder-store ${isFeaturedClass} ${isVipClass}">

            <div class="boa-finder-store-content">
              <p class="boa-finder-store-distance">${distanceText}</p>
                <h3 class="boa-finder-store-name">${store.storename || ""}</h3>
              
                <div class="boa-finder-store-line">
                  ${locationSvg}
                    <p class="boa-finder-store-address">
                       ${store.storeaddress || ""}, ${store.storecity || ""}
                   </p>

               </div>
${vipRibbonHtml}
               <div class="boa-finder-store-buttons">
                   ${callButton}
                   ${navigateButton}
               </div>

               
           </div>
       </div>
   `;
}

async function handleFindMe() {
  // Prevent double execution
  if (isGettingLocation) {
    return;
  }

  hideBoaFinderError();

  // Check if addressInput exists
  const addressInput = document.getElementById("boa-finder-address");
  if (!addressInput) {
    console.error("Address input field not found!");
    return;
  }

  // Check if we're on HTTPS
  if (location.protocol !== "https:" && location.hostname !== "localhost") {
    showBoaFinderError(FoxTheme.boaFinderStrings.errorRequiredHttps);
    return;
  }

  isGettingLocation = true;

  try {
    const position = await getLocationWithFallback({
      enableHighAccuracy: true,
    });

    const { latitude, longitude } = position.coords;
    currentLat = latitude;
    currentLng = longitude;

    // Use Google Maps JavaScript Geocoder instead of REST API
    if (!window.google?.maps) {
      throw new Error("Google Maps not available");
    }

    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: latitude, lng: longitude };

    geocoder.geocode(
      { location: latlng, language: "iw" },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            const address = results[0].formatted_address;
            addressInput.value = address;

          } else {
            console.error("No results from geocoding");
          }
        } else {
          console.error("Geocoder failed:", status);
          showBoaFinderError(FoxTheme.boaFinderStrings.errorGeocoder + status);
        }
      }
    );
  } catch (err) {
    console.error("Location error:", err);
    showBoaFinderError(
      err.message || FoxTheme.boaFinderStrings.errorGettingLocation
    );
  } finally {
    isGettingLocation = false;
  }
}
function getLocationWithFallback(options = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error(FoxTheme.boaFinderStrings.errorBrowserSupport));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos),
      (err) => {
        let errorMessage = "";
        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorMessage = FoxTheme.boaFinderStrings.errorPermissionDenied;
            break;
          case err.POSITION_UNAVAILABLE:
            errorMessage = FoxTheme.boaFinderStrings.errorPositionUnavailable;
            break;
          case err.TIMEOUT:
            errorMessage = FoxTheme.boaFinderStrings.errorTimeout;
            break;
          default:
            errorMessage = FoxTheme.boaFinderStrings.errorGettingLocation;
        }
        reject(new Error(errorMessage));
      },
      {
        enableHighAccuracy: options.enableHighAccuracy || true,
        timeout: options.timeout || 30000,
        maximumAge: options.maximumAge || 0,
      }
    );
  });
}

function showBoaFinderPopup() {
  document.getElementById("boa-finder-container").style.display = "block";
}
function hideBoaFinderPopup() {
  document.getElementById("boa-finder-container").style.display = "none";
}
function showBoaFinderError(msg) {
  const errorEl = document.getElementById("boa-finder-error");
  if (errorEl) {
    errorEl.textContent = msg;
    errorEl.classList.add("show");
  }
}
function hideBoaFinderError() {
  const errorEl = document.getElementById("boa-finder-error");
  if (errorEl) {
    errorEl.textContent = "";
    errorEl.classList.remove("show");
  }
}
